/**
 * MSAL configuration for portal.
 *
 * Uses shared @platform-ui/auth utilities for config building,
 * with portal-specific domain mappings for HRD.
 */

import { createAuthSetup, type AuthConfig, type HrdDomainMapping } from '@platform-ui/auth';
import { env } from '@/config/env';

/**
 * Complete auth setup created from env.auth config.
 */
export const { msalConfig, defaultAuthority, isAuthDisabled, hrdEnabled, apiScopes } = createAuthSetup(env.auth as AuthConfig);

/**
 * Portal-specific domain-to-tenant mappings for HRD.
 * Customize these mappings for your organization's needs.
 */
export const domainMappings: HrdDomainMapping[] = [
    // Example mappings - uncomment and customize as needed:
    // { domain: 'contoso.com', authority: 'https://login.microsoftonline.com/<CONTOSO_TENANT_ID>' },
    // { domain: 'fabrikam.com', authority: 'https://login.microsoftonline.com/<FABRIKAM_TENANT_ID>' },
];
